type EnvironmentKey = "localhost" | "dev" | "prod";

const API_BY_ENV: Record<EnvironmentKey, string> = {
  localhost: "http://localhost:8080/api",
  dev: "https://fixmanhr-be-dev-39426ef9ad7a.herokuapp.com/api",
  prod: "https://fixman-hr-node-deploy-db4ade5f8887.herokuapp.com/api",
};

const currentEnv =
  (process.env.REACT_APP_ENVIRONMENT as EnvironmentKey) ||
  (process.env.NODE_ENV === "development" ? "localhost" : "prod");

export const BASE_API_URL =
  process.env.REACT_APP_API_URL || API_BY_ENV[currentEnv] || API_BY_ENV.prod;

export const constants = {
  currency: "RSD",
};
